export default __webpack_public_path__ + "static/media/cross.f9b185d0.svg";